module.exports = __webpack_public_path__ + "static/media/logoX.254ab50a.jpg";